// Icone e colori dei servizi dell'area clienti (scelti dallo studio in "Gestisci servizi").
// Le classi sono scritte per intero perché Tailwind le includa nel CSS.
import {
  Tv, IdCard, Home, Zap, Shield, Wifi, Briefcase, Building2, Car, Heart, FileText, Euro, Users, Plane,
  GraduationCap, Baby, Landmark, Phone, Globe, Calculator,
} from 'lucide-react';

export const ICONE = {
  tv: Tv, idcard: IdCard, home: Home, zap: Zap, shield: Shield, wifi: Wifi, briefcase: Briefcase, building: Building2,
  car: Car, heart: Heart, file: FileText, euro: Euro, users: Users, plane: Plane, graduation: GraduationCap, baby: Baby,
  landmark: Landmark, phone: Phone, globe: Globe, calculator: Calculator,
};

export const COLORI = {
  sky: 'bg-sky-100 text-sky-700', violet: 'bg-violet-100 text-violet-700', orange: 'bg-orange-100 text-orange-700',
  amber: 'bg-amber-100 text-amber-700', emerald: 'bg-emerald-100 text-emerald-700', pink: 'bg-pink-100 text-pink-700',
  slate: 'bg-slate-200 text-slate-700', green: 'bg-green-100 text-green-800', red: 'bg-red-100 text-red-700',
  blue: 'bg-blue-100 text-blue-700', teal: 'bg-teal-100 text-teal-700', indigo: 'bg-indigo-100 text-indigo-700',
};

export const stileServizio = (s) => ({ icona: ICONE[s?.icona] || Briefcase, colore: COLORI[s?.colore] || COLORI.slate });
